import { trainingprogram } from '../../../../lib/apiList'
import axios from '../../../../lib/axios'
import { QuestionnaireSubmission, GetProgramsParams } from './type'

export const getAssignedPrograms = async ({
    currentPage,
    recordsPerPage,
}: GetProgramsParams) => {
    const data = {
        pageSize: recordsPerPage ? recordsPerPage : 5,
        pageNumber: currentPage ? currentPage : 1,
    }
    const response = await axios.post(trainingprogram.GETASSIGNEDPROGRAMS, data)
    return response
}

export const getQuestions = async (resourceId: string) => {
    const url = `${trainingprogram.CREATEQUESTIONNAIRE}/${resourceId}`
    const response = await axios.get(url)
    return response
}

export const submitQuestionnaire = async (body: QuestionnaireSubmission) => {
    const response = await axios.post(
        trainingprogram.SUBMITRESOURCEQUESTIONNAIRE,
        body
    )
    return response
}
